<template>
  <template v-if="isLoading">
    <OtherLoading variant="dark" />
  </template>
  <template v-else>
    <div class="profile-container">
      <ProfileSharp
        v-if="$config.isMinimalSharp"
        :profile="profile"
        :userProfile="lineProfile"
        @logout="logout"
        :marketPlaceObj="marketPlaceObject"
        :memberLevel="memberLevel"
      />
      <ProfileCompact
        v-else-if="$isMinimalCompact"
        :profile="profile"
        :userProfile="lineProfile"
        @logout="logout"
        :marketPlaceObj="marketPlaceObject"
        :memberLevel="memberLevel"
      />
      <ProfileMinimalProfile
        v-else-if="$isMinimalProfile"
        :profile="profile"
        :userProfile="lineProfile"
        @logout="logout"
        :marketPlaceObj="marketPlaceObject"
        :memberLevel="memberLevel"
      />
      <ProfileBanner
        v-else-if="$isMinimalProfileBanner"
        :profile="profile"
        :userProfile="lineProfile"
        @logout="logout"
        :marketPlaceObj="marketPlaceObject"
        :memberLevel="memberLevel"
      />
      <ProfileMinimal
        v-else
        :profile="profile"
        :userProfile="lineProfile"
        @logout="logout"
        :marketPlaceObj="marketPlaceObject"
        :memberLevel="memberLevel"
      />
    </div>
  </template>
  <ModalLoading ref="modalLoading" />

</template>

<script>
import ProfileMinimal from "../ProfileLayoutMinimal.vue";
import ProfileCompact from "../ProfileLayoutCompact.vue";
import ProfileSharp from "../ProfileLayoutSharp.vue";

import ProfileMinimalProfile from "../ProfileLayoutMinimalProfile.vue";

import OtherLoading from "@/components/other/OtherLoading";
import ProfileBanner from "../ProfileLayoutProfileBanner.vue";
import ModalLoading from "@/components/other/ModalLoading.vue";
import { useDialog } from "@/services/dialogService";

export default {
  components: {
    ProfileMinimal,
    ProfileCompact,
    ProfileMinimalProfile,
    ModalLoading,
    OtherLoading,
    ProfileSharp,
    ProfileBanner
  },
  setup() {
    const dialog = useDialog();
    return { dialog };
  },
  mounted() {},
  data() {
    return {
      MenuList: [],
      profile: { ...this.$store.state.shortProfile },
      lineProfile: this.$config.isLoginLine
        ? this.$cookies.isKey("user_profile_token")
          ? this.$cookies.get("user_profile_token")
          : this.$store.state.userProvider
        : {},
      isLoading: true,
      filter: {
        SocialProvider: this.$config.socialProvider,
        SocialId: ""
      },
      privilegeList: [],
      notFoundData: false,
      rewardList: [],

      // newsList: [],
      bannerList: [],
      FGFList: [],
      filterBanner: {
        level_id: 1
      },
      marketPlaceObject: [],
      bannerFriend: [],
      customFormList: [],
      bannerIndex: 0,
      memberLevel: { upgrade_baht: 9999, maintain_baht: 9999 },
      filterNews: {
        page: 1,
        take: 10
      }
    };
  },

  async created() {
    this.LoginExternal();
    // console.log(.);
  },
  methods: {
    async getBannerGetFriend() {
      try {
      const res = await this.$axios(`/api/v1/FriendGetFriend/get`);

      this.bannerFriend = res.detail;
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/FriendGetFriend/get",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getBannerGetFriend API request failed" }
        });
        throw error;
      }
    },

    async getBanner() {
      try {
      await this.$axios
        .get(`/api/v1/banner/campaign_form`)
        .then(async data => {
          if (data.result == 1) {
            if (data.detail.totalCount > 0) {
              this.bannerList = data.detail.detail;
            }
          }
        })
        .catch(error => {
          console.log("getBanner", error.message);
        });
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/banner/campaign_form",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getBanner API request failed" }
        });
        throw error;
      }
    },
    async getCouponList() {
      try {
      await this.$axios.get(`/api/v1/privilege/coupon`).then(async data => {
        if (data.result == 1) {
          if (data.detail.length > 0) {
            this.notFoundData = false;
            this.privilegeList = data.detail;
          } else {
            this.notFoundData = true;
          }
        }
      });
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/privilege/coupon",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getCouponList API request failed" }
        });
        throw error;
      }
    },
    async getRewardList() {
      try {
      await this.$axios.get(`/api/v1/redeem/get_redeem_item_list`).then(
        async data => {
          // this.isLoading = false;
          if (data.result == 1) {
            this.rewardList = data.detail;
          }
        },
        error => {
          const code = parseInt(error.response && error.response.status);
          if (code === 401) {
            console.log(error);
          }
        }
      );
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/redeem/get_redeem_item_list",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getRewardList API request failed" }
        });
        throw error;
      }
    },

    async unpairfunc() {
      try {
        this.$refs.modalLoading.show();
        const data = await this.$store.dispatch("unpairUser");
        if (data.result == 1) {
          this.$refs.modalLoading.hide();
          await this.$router.replace("/validatetelephone");
        } else window.alert("Internal Server Error.");
      } catch (error) {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$refs.modalLoading.hide();
        await this.$router.replace("/validatetelephone");
      }
    },
    async logout() {
      const result = await this.dialog.showConfirm({
        text: this.$t("confirm_logout"),
        button: {
          true: { msg: this.$t("confirm"), class: ["btn-danger"] },
          false: { msg: this.$t("cancel"), class: ["btn-secondary"] }
        }
      });
      if (result) {
        await this.unpairfunc();
      }
    },
    async LoginExternal() {
      // await this.memberDesc(this.profile.member_level_id);
      // this.getBanner();
      // this.getMenuList();
      // this.getBannerGetFriend();
      // this.getMarketPlace();

      this.isLoading = false;
    },

    async getMarketPlace() {
      try {
        const data = await this.$axios(`/api/v1/User/get/marketplace`);
        this.marketPlaceObject = data.detail;
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/User/get/marketplace",
              method: "GET",
              methods: "GET",
              data: ""
            }
          },
          action: { id: 3, action: "getMarketPlace API request failed" }
        });
        console.log("getMarketPlace", error.message);
      }
    },

    async memberDesc(id) {
      this.memberLevel = this.$store.state.shortProfile.member_list.find(
        el => el.is_default == 1
      );
    },
    async getNewsList() {
      try {
      await this.$axios
        .post(`/api/v1/MonthlyPrivilege/list`, this.filterNews)
        .then(async data => {
          if (data.result == 1) {
            this.newsList = data.detail.detail;
            this.isLoading = false;
          }
        });
      } catch (error) {
        this.$logger({
          response: error?.response || {
            config: error?.config || {
              url: "/api/v1/MonthlyPrivilege/list",
              method: "POST",
              methods: "POST",
              data: ""
            }
          },
          action: { id: 3, action: "getNewsList API request failed" }
        });
        throw error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-container {
  position: relative;
  // background: white;
  // margin: 1rem;
  // border-radius: 5px;
}
.menulist-container {
  background: white;
  border-radius: 5px;
  margin: 1rem;

  // padding-bottom: 100px;
}

.line-text-pf {
  border-left: 6px solid black;
}
.btn-unpair {
  background-color: transparent;
  border: none;
  color: #bebebe;
}
.w-90 {
  width: 90%;
}
.banner-friend {
  img {
    border-radius: 5px;
    aspect-ratio: 16/9;
  }
}
</style>
